import React, { useEffect, useState } from "react";
import NavBar from "./components/NavBar";
import Card from "./components/Card";
import Prestations from "./components/Prestations";
import Contact from "./components/Contact";
import Legal from "./components/Legal";
import GlobalStyles from "./GlobalStyles";
import logo from "./logo.png";
import atelier from "./atelier25.svg";

import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { IoIosArrowDown, IoIosClose } from "react-icons/io";
import {
  motion,
  useScroll,
  useTransform,
  AnimatePresence,
} from "framer-motion";
import { request } from "graphql-request";

function App() {
  const isCpu = useMediaQuery({ minWidth: 768 });
  const { scrollY } = useScroll();
  const opacity = useTransform(scrollY, [0, 200], [0.7, 0.9]);
  const opacityTitle = useTransform(scrollY, [0, 100], [0.5, 0]);
  const [assets, setAssets] = useState(null);
  const [loading, setLoaded] = useState(true);
  const [background, setBackground] = useState(null);
  const [legal, setLegal] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      const { assets } = await request(
        `${process.env.REACT_APP_HYGRAPH_API_URL}`,
        `
        {
          assets(orderBy: publishedAt_DESC, last: 100) {
            id
            url
          }
        }
    `
      );
      setAssets(assets);
      setBackground(
        assets.find((asset) =>
          isCpu
            ? asset.id === "cli526igxj15s0bw2839ciz6i"
            : asset.id === "cli526ihjj21x0bw6pn3d6c71"
        )
      );
    };
    fetchProducts();
  }, [isCpu]);
  const onLoad = () => {
    setLoaded(false);
  };
  console.log(loading);
  return (
    <AppContainer>
      <GlobalStyles />
      <div className={loading ? "scrollStop" : ""}>
        {assets && (
          <>
            <AnimatePresence initial={false}>
              {loading && (
                <LoadingContainer
                  animate={{
                    opacity: 1,
                  }}
                  exit={{
                    opacity: 0,
                    transition: { duration: 1.5, ease: "easeIn" },
                  }}
                >
                  <motion.div
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.01 } }}
                    className="loadingio-spinner"
                  >
                    <img
                      src={atelier}
                      alt="logo"
                      className="atelier"
                    />
                    <div className="ldio">
                      <div></div>
                      <img
                        src={logo}
                        alt="logo"
                        className="logo"
                      />
                    </div>
                  </motion.div>
                </LoadingContainer>
              )}
            </AnimatePresence>
            <NavBar />
            <Header
              id="home"
              className={loading ? "scrollStop" : ""}
            >
              <img
                src={background.url}
                alt="Line qui tattoo"
                onLoad={onLoad}
                loading="lazy"
              />
              <Filter style={{ opacity: opacity }} />
              <FilterTwo />
              <motion.div
                className="down"
                style={{ opacity: opacityTitle }}
              >
                <IoIosArrowDown size={50} />
              </motion.div>
            </Header>
            <Main id="portfolio">
              <h1>Portfolio</h1>
              <Card assets={assets} />
            </Main>
            <Section id="prestations">
              <Prestations />
            </Section>
            <Section id="contact">
              <Contact />
            </Section>
            <Footer>
              <p>{`© ${new Date().getFullYear()} LM Atelier 25`}</p>
              <p>
                Développé par :{" "}
                <a
                  href="https://jcesardesign.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  jcesardesign.com
                </a>{" "}
              </p>
              <p
                className="mentions"
                onClick={() => setLegal(true)}
              >
                Mentions Légales
              </p>
              {legal && (
                <LegalContainer>
                  <IoIosClose
                    size={100}
                    onClick={() => setLegal(false)}
                    className="close"
                  />{" "}
                  <Legal />
                </LegalContainer>
              )}
            </Footer>
          </>
        )}
      </div>
    </AppContainer>
  );
}

export default App;

const AppContainer = styled.div`
  height: fit-content;
  .scrollStop {
    height: 100vh;
    overflow: hidden;
  }
`;

const Header = styled.header`
  height: 100vh;
  width: 100%;

  top: 0;
  display: flex;
  justify-content: center;
  img {
    z-index: -2;
    position: fixed;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
  }
  .down {
    position: fixed;
    z-index: 1;
    color: #fff;
    inset: auto auto 5px auto;
  }
  .scrollStop {
    overflow: hidden;
  }
`;

const Filter = styled(motion.div)`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(rgba(0, 0, 0, 0.6) 0%, #000 50%);
  filter: blur(10px);
  z-index: -1;
  @media (max-width: 768px) {
    background-image: radial-gradient(rgba(0, 0, 0, 0.6) 0%, #000 80%);
  }
`;

const FilterTwo = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0;
  z-index: -1;
`;

const Main = styled.main`
  padding-top: 10vh;
  width: 100%;
  height: fit-content;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Section = styled.section`
  padding-top: 10vh;
  width: 100%;
  height: fit-content;
  color: white;
  display: flex;
  justify-content: center;
`;

const Footer = styled.footer`
  padding-top: 10vh;
  width: 100%;
  height: 10vh;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.1rem;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 10vh;
  }
  p {
    margin: 2vh 5vw;
    font-weight: 100;
  }
  .mentions {
    cursor: pointer;
  }
`;

const LegalContainer = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  inset: 40% 0 0 0;
  overflow: scroll;
  background: black;
  color: white;
  overscroll-behavior: contain;
  .close {
    position: fixed;
    cursor: pointer;
    background: black;
    border-radius: 50%;
  }
`;

const LoadingContainer = styled(motion.div)`
  position: fixed;
  inset: 0;
  overflow: hidden;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  @keyframes ldio {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio div {
    position: absolute;
    animation: ldio 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #8f601a;
    transform-origin: 80px 82px;
  }
  .loadingio-spinner {
    position: absolute;
    width: 200px;
    height: 200px;
    background: black;
    .logo {
      position: absolute;
      width: 150px;
      top: 25px;
      left: 25px;
    }
    .atelier {
      position: absolute;
      top: -50px;
      left: -50px;
    }
  }
  .ldio {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio div {
    box-sizing: content-box;
  }
  /* generated by https://loading.io/ */
`;
